/*
╔═╗┌─┐┌─┐┬─┐┌─┐┌─┐┬┌─┬ ┬┌┬┐┌┬┐┬ ┬
║ ╦├┤ │ │├┬┘│ ┬├┤ ├┴┐│ │ │  │ └┬┘
╚═╝└─┘└─┘┴└─└─┘└─┘┴ ┴└─┘ ┴  ┴  ┴ 
DesignedAndDevelopedBy:Georgekutty @11-09-2019 20:58:43
*/


const forgetPasswordDetailsReducer = (state = {username:"",password:"",profileID:"",emailFromAPI:"",numberFromAPI:"",email:"",mobileNumber:"",msisdn:"",generatedOtp:"",enteredOtpViaEmail:"",enteredOtpViaNumber:"",retreivedUsername:"",questionAnswerArray:[]}, action) => {
	if (action.type === 'SET_FORGET_PASSWORD_DETAILS') {
		var newState = {};
		Object.assign(newState, state);
		insertDataIntoGivenPath(newState,action.key,action.payload);
		console.log("forgetPasswordDetailsReducer newState >>", newState);
		return newState;
	} else {
		return state
	}
}

function insertDataIntoGivenPath(obj, props, newValue) {
	var propsArr = props.split('.');
	var prop = propsArr.splice(0, 1);
	var nextObject = obj[prop];
	if (!propsArr.join('.')) {
		return obj[prop] = newValue;
	} else {
		insertDataIntoGivenPath(nextObject, propsArr.join('.'), newValue);
		return obj;
	}
}

export default forgetPasswordDetailsReducer;
